import { render, staticRenderFns } from "./GenerateProfile.vue?vue&type=template&id=988fc4e6&"
import script from "./GenerateProfile.vue?vue&type=script&lang=js&"
export * from "./GenerateProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports